export default (
  stroke = '#1043E7'
) => `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5442 6.40035e-07L18 5.66722L25.4558 0L26.7206 9.27941L36 10.5442L30.3328 18L36 25.4558L26.7206 26.7206L25.4558 36L18 30.3328L10.5442 36L9.27941 26.7206L6.40035e-07 25.4558L5.66722 18L0 10.5442L9.27941 9.27941L10.5442 6.40035e-07Z" fill="${stroke}"/>
</svg>
`;
